
// import React, { useEffect, useState } from "react";
// import {
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   LabelList,
//   Legend,
//   Brush, // Import Brush for zoom functionality
// } from "recharts";
// import { InverterDetail2 } from "../../../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material"; // Import icons
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress"; // Loading spinner
// import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";

// const Tab4DailyEnergy = () => {
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false); // Loading state
//   const [tye] = useState("I");

//   // Move credentials logic into a separate function to keep it dynamic
//   const getCredentials = () => ({
//     LOGIN_ID: localStorage.getItem("LoginID") || "",
//     LOC_CODE: localStorage.getItem("LCODE") || "",
//     PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     TYE: tye,
//   });

//   // Fetch data from the API
//   const fetchLogData = async () => {
//     setLoading(true); // Set loading to true before fetching data
//     const credentials = getCredentials(); // Get the latest credentials
//     try {
//       const res = await InverterDetail2(credentials);

//       if (res?.data && Array.isArray(res.data)) {
//         console.log("Fetched Data:", res.data);
//         const transformedData = res.data.map((item) => ({
//           name: item.NAME, // Replace with appropriate key for labels
//           Peak_KW: parseFloat(item.KW_MAX) || 0, // Replace with the key for peak KW
//           KWp: parseFloat(item.KWP) || 0, // Replace with the key for KWp
//           KW: parseFloat(item.KW) || 0, // Replace with the key for KW
//           DAY_KWH: parseFloat(item.DAY_KWH) || 0, // Add Today KWH
//         }));

//         setChartData(transformedData);
//       } else {
//         console.error("Data structure mismatch:", res);
//         setChartData([]); // Set empty array on data mismatch
//       }
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     } finally {
//       setLoading(false); // Set loading to false after data is fetched
//     }
//   };

//   // Fetch data on component mount
//   useEffect(() => {
//     fetchLogData();
//   }, []); // Empty dependency array to run only once on mount

//   return (
//     <>
//       <div className="row">
//         <div className="col-md-12" style={{ height:"18rem", position: "relative" }}>
//           {/* Refresh Button */}
//           <div style={{
//             marginBottom: "4px", cursor: "pointer",
//             position: "absolute",
//             top: "10px",
//             right: "10px",
//             zIndex: 1,
//             color: "#00FFFF",
//             fontSize: "24px",
//           }}>
//             <IconButton onClick={fetchLogData} disabled={loading}>
//               <Refresh />
//             </IconButton>
//             {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//           </div>

//           {/* Chart */}
//           {loading ? (
//             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//               <CircularProgress />
//             </div>
//           ) : (
//             <ResponsiveContainer>
//               <ComposedChart
//                 data={chartData}
//                 margin={{ top: 20, right: 40, left: 40, bottom: 5 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name"
//                   stroke="white" // ✅ axis line and 
//                   tick={{ fill: "white" }} // ✅ tick text color

//                 />
//                 <YAxis yAxisId="left"
//                   stroke="white" // ✅ axis line and 
//                   tick={{ fill: "white" }} // ✅ tick text color
//                 />
//                 <YAxis yAxisId="right" orientation="right"
//                   stroke="white" // ✅ axis line and 
//                   tick={{ fill: "white" }} // ✅ tick text color
//                 />
//                 <Tooltip />

//                 {/* Add Legend */}
//                 <Legend
//                   layout="horizontal"
//                   verticalAlign="top"
//                   align="center"
//                   wrapperStyle={{
//                     paddingBottom: "10px", // Space between legend and chart
//                     fontSize: "12px", // Adjust font size
//                   }}
//                 />

//                 {/* Bars for Peak KW, KWp, and KW */}
//                 <Bar dataKey="Peak_KW" fill="#00FFFF" name="Peak KW" yAxisId="left">
//                   <LabelList
//                     dataKey="Peak_KW"
//                     position="top"
//                     style={{ fill: "#00FFFF", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>
//                 <Bar dataKey="KWp" fill={LoggedInUserInfo.dash_color} name="KWp" yAxisId="left">
//                   <LabelList
//                     dataKey="KWp"
//                     position="top"
//                     style={{ fill: LoggedInUserInfo.dash_color, fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>
//                 <Bar dataKey="KW" fill="#0000ff" name="KW" yAxisId="left">
//                   <LabelList
//                     dataKey="KW"
//                     position="top"
//                     style={{ fill: "#0000ff", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>

//                 {/* Line for DAY_KWH with data labels */}
//                 <Line
//                   type="monotone"
//                   dataKey="DAY_KWH"
//                   stroke="#ff0000"
//                   name="Today KWH"
//                   yAxisId="right"
//                   strokeWidth={2}
//                 >
//                   <LabelList
//                     dataKey="DAY_KWH"
//                     position="top"
//                     style={{ fill: "#ff0000", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Line>

//                 {/* Brush Component for Zooming */}
//                 <Brush
//                   dataKey="name"
//                   height={30}
//                   stroke="red"
//                   startIndex={0}
//                   endIndex={10}
//                 />
//               </ComposedChart>
//             </ResponsiveContainer>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Tab4DailyEnergy;



import React, { useEffect, useState, useContext } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend,
} from "recharts";
import { InverterDetail2 } from "../../../../../../../../api/Api";
import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";



const Tab4DailyEnergy = () => {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tye] = useState('I');

  const getCredentials = () => ({
    LOGIN_ID: localStorage.getItem('LoginID') || '',
    LOC_CODE: localStorage.getItem('LCODE') || '',
    PASS_KEY: localStorage.getItem('PASS_KEY') || 'DEFAULT_PASS_KEY',
    WEB_KEY: localStorage.getItem('WEB_KEY') || 'DEFAULT_WEB_KEY',
    TYE: tye,
  });

  const fetchLogData = async () => {
    setLoading(true);
    try {
      const res = await InverterDetail2(getCredentials());
      if (res?.data && Array.isArray(res.data)) {
        setChartData(res.data.map(item => ({
          name: item.NAME,
          DAY_KWH: parseFloat(item.DAY_KWH) || 0,
          CUF: parseFloat(item.CUF) || 0,
        })));
      } else {
        console.error('Data structure mismatch:', res);
        setChartData([]);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      setChartData([]);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchLogData();
  // }, []);

  useEffect(() => {
    // run immediately
    fetchLogData();

    // run every 5 minutes
    const interval = setInterval(() => {
      fetchLogData();
    }, 300000); // 5 minutes = 300,000 ms

    // cleanup interval
    return () => clearInterval(interval);
  }, []);


  return (
    <div className="row">
      <div className="col-md-12" style={{ height: '21.4rem', position: 'relative' }}>
        <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}>
          <IconButton onClick={fetchLogData} disabled={loading}>
            <Refresh />
          </IconButton>
          {loading && <CircularProgress size={24} style={{ marginLeft: 10 }} />}
        </div>

        {loading ? (
          <div style={{
            display: 'flex', justifyContent: 'center',
            alignItems: 'center', height: '100%',
          }}>
            <CircularProgress />
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              data={chartData}
              margin={{ top: 0, right: 40, left: 40, bottom: 60 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#555" />

              <XAxis
                dataKey="name" angle={-45} textAnchor="end" height={70}
                tick={{ fill: 'black' }} axisLine={{ stroke: 'black' }} tickLine={{ stroke: 'black' }}
              />

              <YAxis
                yAxisId="left"
                tick={{ fill: 'black' }} axisLine={{ stroke: 'black' }} tickLine={{ stroke: 'black' }}
                label={{
                  value: 'Today KWH',
                  angle: -90,
                  position: 'insideLeft',
                  offset: 10,
                  fill: 'black',
                }}
              />

              <YAxis
                yAxisId="right"
                orientation="right"
                tick={{ fill: 'black' }} axisLine={{ stroke: 'black' }} tickLine={{ stroke: 'black' }}
                label={{
                  value: 'CUF',
                  angle: 90,
                  position: 'insideRight',
                  offset: 10,
                  fill: 'black',
                }}
              />

              <Tooltip cursor={{ fill: 'transparent' }} />

              <Legend
                layout="horizontal"
                verticalAlign="top"
                align="center"
                wrapperStyle={{ paddingBottom: '10px', color: 'black' }}
              />

              <Bar
                dataKey="DAY_KWH"
                fill="#5CA904"
                name="Today KWH"
                yAxisId="left"
                barSize={30}
              />

              <Line
                type="monotone"
                dataKey="CUF"
                stroke="red"
                strokeWidth={2}
                dot={{ r: 3 }}
                name="CUF"
                yAxisId="right"
              />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default Tab4DailyEnergy;

